import { createClient } from "@supabase/supabase-js";
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY;
const header = {
  auth: {
    redirectTo: window.location.origin,
  },
};
export const supabase = createClient(supabaseUrl, supabaseAnonKey, header);
